import { memoize } from 'lodash'
import { createSelector } from 'reselect'
import { BotFeatures } from '@feedyou-ai/feedbot-schema'

import { RootState } from '../../reducers'
import { isAiOrLlmInvokeStep } from './utils'
import { featureValueSelector } from '../../store/features/selectors'
import { allStepsSelector } from '../../store/flow/selectors/selectors'
import { sdkFeatureSelector } from '../hostingVersions/selectors/sdkFeatureSelector'

//note: memoize can protect against circular dependency
export const allAiAndLlmInvokeStepsSelector = memoize(() =>
  createSelector(
    allStepsSelector, // I <3 PRETTIER
    allSteps => allSteps.filter(isAiOrLlmInvokeStep)
  )
)

//@ts-ignore
export const areNlpChatQueriesEnabledSelector = createSelector(
  //@ts-ignore
  (state: RootState): boolean => sdkFeatureSelector(state, BotFeatures.NLP_CHAT_QUERIES),
  featureValueSelector('NLP_CHAT_QUERIES'),
  (botFeatureFlag: boolean, designerFeatureFlag?: boolean): boolean =>
    botFeatureFlag && !!designerFeatureFlag
)
